import { event } from 'jquery';
import { qs, qsa, triggerAPI } from './util';
import { trackSegmentAndLJ } from './segment/segment-utils';

insertURLWithEmail();

const calculatorContainer = document.getElementsByClassName(
    'rc-hero__calculator'
  )[0],
  resultContainer = document.getElementsByClassName('rc-hero__result')[0],
  resultAmount = resultContainer.getElementsByClassName(
    'rc-hero__result--amount'
  )[0],
  calcEmail = qs('#calc-email'),
  calcRevenue = qs('#calc-revenue'),
  calcFailures = qs('#calc-failures'),
  formInput = {
    email: null,
    averageMonthlyRevenue: null,
    nonMetroCustomers: null,
    digital: null,
    multiplePaymentOptions: null,
    transactionFailures: 0
  },
  baseValue = [25, 125, 350, 750, 1500, 2000],
  eventLaterQuestion = [
    {
      matchField: 'email',
      qTitle: 'Email entry field'
    },
    {
      matchField: 'revenue',
      qTitle: 'Q1: Average monthly revenue entry',
      q: 'What is your average monthly revenue?'
    },
    {
      matchField: 'nonMetroCustomers',
      qTitle: 'Q2: Non-metro cities customer entry',
      q: 'Do you have customers from non-metro cities?'
    },
    {
      matchField: 'digital',
      qTitle: 'Q3: Using payment solution? entry',
      q: 'Are you currently using a digital payment solution?'
    },
    {
      matchField: 'multiplePaymentOptions',
      qTitle: 'Q4: payment modes entry',
      q: 'Do you offer customers EMI, Paylater payment options?'
    },
    {
      matchField: 'failures',
      qTitle: 'Q5: payment failures entry',
      q: 'How many transaction failures do you face, monthly?'
    },
    {
      matchField: 'calculate',
      qTitle: 'CTA Click: Calculate',
      q: 'Increase my revenue by'
    },
    {
      matchField: 'totalSavings',
      qTitle: 'CTA Click: Increase my revenue',
      q: 'Increase my revenue by'
    }
  ],
  allQuestAns = [];

let stepState = 0;

$('#razorpay-logo-footer')[0].setAttribute(
  'src',
  '/assets/razorpay-logo-white.svg'
);

function recordRevenueEvent(e) {
  const revenueVal = calcRevenue.value;
  let totalRevenue = 0;
  if (revenueVal === '0') {
    totalRevenue = 'Less than ₹50,000';
  } else if (revenueVal === '1') {
    totalRevenue = '₹50,000 to ₹2,00,000';
  } else if (revenueVal === '2') {
    totalRevenue = '₹2,00,000 to ₹5,00,000';
  } else if (revenueVal === '3') {
    totalRevenue = '₹5,00,000 to ₹10,00,000';
  } else if (revenueVal === '4') {
    totalRevenue = '₹10,00,000 to ₹20,00,000';
  } else if (revenueVal === '5') {
    totalRevenue = '₹20,00,000 and above';
  }

  allQuestAns.push({
    q: eventLaterQuestion[1].q,
    qa: totalRevenue
  });

  trackSegmentAndLJ(e, eventLaterQuestion[1].qTitle, {
    email: sessionStorage.getItem('email'),
    fold: 'first-fold',
    questions: allQuestAns
  });
}

function changeStep(e, action) {
  action = e;
  sessionStorage.setItem('email', calcEmail.value);
  switch (stepState) {
    case 0:
      if (!calcEmail.value || calcEmail.checkValidity() === false) {
        calcEmail.className = 'bounce';
        setTimeout(function() {
          calcEmail.className = '';
        }, 1000);
        return;
      }
      formInput.email = calcEmail.value;
      allQuestAns.push({
        action: `Email entered ${sessionStorage.getItem('email')}`,
        email: sessionStorage.getItem('email')
      });
      trackSegmentAndLJ(arguments[1], eventLaterQuestion[0].qTitle, {
        email: sessionStorage.getItem('email'),
        fold: 'first-fold',
        questions: allQuestAns
      });
      break;
    case 1:
      if (calcRevenue.value === 'default') {
        calcRevenue.className = 'bounce';
        setTimeout(function() {
          calcRevenue.className = '';
        }, 1000);
        return;
      } else {
        formInput.averageMonthlyRevenue = calcRevenue.value;
        recordRevenueEvent(arguments[1]);
      }
      break;
    case 2:
      if (formInput.nonMetroCustomers === null && action === 1) {
        var buttons = document
          .getElementsByClassName('rc-hero__calculator--step-3-fields')[0]
          .getElementsByTagName('button');

        if (buttons) bounceButtons(buttons);
        return;
      }
      break;
    case 3:
      if (formInput.digital === null && action === 1) {
        var buttons = document
          .getElementsByClassName('rc-hero__calculator--step-4-fields')[0]
          .getElementsByTagName('button');

        if (buttons) bounceButtons(buttons);
        return;
      }
      break;
    case 4:
      if (formInput.multiplePaymentOptions === null && action === 1) {
        var buttons = document
          .getElementsByClassName('rc-hero__calculator--step-5-fields')[0]
          .getElementsByTagName('button');

        if (buttons) bounceButtons(buttons);
        return;
      }
      break;
    case 5:
      if (action === 1) {
        if (
          !calcFailures.value ||
          Number(calcFailures.value) < 0 ||
          Number(calcFailures.value) > 100
        ) {
          calcFailures.className = 'bounce';
          setTimeout(function() {
            calcFailures.className = '';
          }, 1000);
          return;
        } else {
          formInput.transactionFailures = calcFailures.value;
          calculateResult();
          return;
        }
      }
    default:
      break;
  }

  stepState += action;

  calculatorContainer.className =
    'rc-hero__calculator center rc-hero__calculator--step-' +
    String(stepState + 1);
}

function changeStepBoolean(e, field, value) {
  e = arguments[2];
  field = arguments[0];
  value = arguments[1];

  formInput[field] = value;
  if (field === 'digital' && value === false) {
    calculateResult();
  } else {
    changeStep(1, null);
  }
  const question = eventLaterQuestion.filter(data => data.matchField === field);

  allQuestAns.push({
    q: question[0].q,
    qa: value ? 'Yes' : 'No'
  });

  trackSegmentAndLJ(e, question[0].qTitle, {
    email: sessionStorage.getItem('email'),
    fold: 'first-fold',
    questions: allQuestAns
  });
}

function calculateResult() {
  let total = baseValue[Number(formInput.averageMonthlyRevenue)],
    totalBaseValue = total;

  if (
    (formInput.nonMetroCustomers === true &&
      formInput.multiplePaymentOptions === false) ||
    formInput.digital === false
  )
    total = total * 1.35 - totalBaseValue;
  else if (
    formInput.nonMetroCustomers === true &&
    formInput.multiplePaymentOptions === true
  )
    total = total * 1.15 - totalBaseValue;
  else if (
    formInput.nonMetroCustomers === false &&
    formInput.multiplePaymentOptions === false
  )
    total = total * 1.3 - totalBaseValue;

  let increasedRevenue = '₹' + Math.round(total * 1000).toLocaleString('en-IN');
  resultAmount.innerHTML = increasedRevenue;

  calculatorContainer.style.display = 'none';
  resultContainer.style.display = 'block';

  allQuestAns.push({
    result: `CTA Click: Increase revenue by ${increasedRevenue}`,
    increase: increasedRevenue
  });
  trackSegmentAndLJ('', eventLaterQuestion[6].qTitle, {
    email: sessionStorage.getItem('email'),
    fold: 'first-fold',
    questions: allQuestAns
  });

  let emailMehubspotPayload = {
    fields: [
      {
        name: 'email',
        value: sessionStorage.getItem('email')
      },
      {
        name: 'metro_or_not',
        value: allQuestAns.length ? allQuestAns[2].qa : ''
      },
      {
        name: 'accept_payments_online',
        value: allQuestAns.length ? allQuestAns[3].qa : ''
      },
      {
        name: 'multiple_modes_of_payment',
        value: allQuestAns.length ? allQuestAns[4].qa : ''
      },
      {
        name: 'payment_failure_numbers',
        value: allQuestAns.length ? allQuestAns[5].qa : ''
      },
      {
        name: 'aveage_monthly_revenue_final',
        value: allQuestAns.length ? allQuestAns[1].qa : ''
      },
      {
        name: 'estimated_revenue_boost',
        value: allQuestAns.length ? allQuestAns[1].qa : ''
      }
    ],
    context: {
      pageUri: `www.${window.location.hostname}/${window.location.pathname}`,
      pageName: 'Razorpay #GrowYourRevenue'
    },
    legalConsentOptions: {
      consent: {
        // Include this object when GDPR options are enabled
        consentToProcess: true,
        text:
          'I agree to allow Razorpay to store and process my personal data.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 6760497,
            text: 'I agree to receive marketing communications from Razorpay.'
          }
        ]
      }
    }
  };

  triggerAPI(
    'https://api.hsforms.com/submissions/v3/integration/submit/5558946/eeca97b5-09fe-453a-b9c1-080d9695fbf4',
    'POST',
    response => {
      let res = response && JSON.parse(response);
      if (res.error) {
        console.log('Error while processing your request', res.error);
      }
    },
    emailMehubspotPayload
  );
  insertURLWithEmail();
}

function insertURLWithEmail() {
  if (sessionStorage && sessionStorage.getItem('email')) {
    qsa('.increase-revenue').forEach(element => {
      let currentHref = element.getAttribute('href').split('&');
      let currentHost = currentHref[0].split('?');
      element.setAttribute(
        'href',
        `${currentHost[0]}?email=${btoa(sessionStorage.getItem('email'))}&${
          currentHost[1]
        }&${currentHref[1]}&${currentHref[2]}&${currentHref[3]}`
      );
    });
  }
}

function numberInputHandler(e) {
  if (Number(e.target.value) < 0 || !e.target.value) e.target.value = 0;
  if (Number(e.target.value) > 100) e.target.value = 100;
  allQuestAns.push({
    q: eventLaterQuestion[5].q,
    qa: calcFailures.value
  });
  trackSegmentAndLJ(e, eventLaterQuestion[5].qTitle, {
    email: sessionStorage.getItem('email'),
    fold: 'first-fold',
    questions: allQuestAns
  });
}

function bounceButtons(buttons) {
  for (var i = 0; i < buttons.length; i++) {
    buttons.item(i).className = buttons.item(i).className + ' bounce';
  }
  setTimeout(function() {
    for (var i = 0; i < buttons.length; i++) {
      buttons.item(i).className = buttons
        .item(i)
        .className.replace('bounce', '');
    }
  }, 1000);
}

qs('.rc-hero__calculator--next').addEventListener(
  'click',
  changeStep.bind(event, 1)
);

qs('.rc-hero__calculator--prev').addEventListener(
  'click',
  changeStep.bind(event, -1)
);

qs('.color-link.metro-cities').addEventListener(
  'click',
  changeStepBoolean.bind(event, 'nonMetroCustomers', true)
);

qs('.non-metro-cities').addEventListener(
  'click',
  changeStepBoolean.bind(event, 'nonMetroCustomers', false)
);

qs('.color-link.is-digital').addEventListener(
  'click',
  changeStepBoolean.bind(event, 'digital', true)
);

qs('.no-digital').addEventListener(
  'click',
  changeStepBoolean.bind(event, 'digital', false)
);

qs('.color-link.emi-yes').addEventListener(
  'click',
  changeStepBoolean.bind(event, 'multiplePaymentOptions', true)
);

qs('.emi-no').addEventListener(
  'click',
  changeStepBoolean.bind(event, 'multiplePaymentOptions', false)
);

qs('#calc-failures').addEventListener('change', numberInputHandler.bind(event));

qs('.rc-hero__calculator--finish.button').addEventListener(
  'click',
  changeStep.bind(event, 1)
);

qs('.rc-hero__right-img a').addEventListener('click', e => {
  trackSegmentAndLJ(e, 'CTA Click : T&C page', {
    email: sessionStorage.getItem('email')
      ? sessionStorage.getItem('email')
      : 'Not Filled',
    fold: 'first-fold',
    questions: allQuestAns.length ? allQuestAns : 'Not Answered'
  });
});

qsa('.increase-revenue').forEach(element => {
  element.addEventListener('click', e => {
    trackSegmentAndLJ(e, 'CTA Click: Increase my revenue', {
      email: sessionStorage.getItem('email')
        ? sessionStorage.getItem('email')
        : 'Not Filled',
      fold: e.currentTarget.classList[2],
      questions: allQuestAns.length ? allQuestAns : 'Not Answered'
    });
  });
});

qs('a.cal-increase-revenue').addEventListener('click', e => {
  allQuestAns.push({
    event: allQuestAns.length
      ? eventLaterQuestion[7].q + ' ' + allQuestAns[6].increase
      : '',
    url: qs('a.cal-increase-revenue').getAttribute('href')
  });
  trackSegmentAndLJ(e, eventLaterQuestion[7].qTitle, {
    email: sessionStorage.getItem('email'),
    fold: 'first-fold',
    questions: allQuestAns
  });
});

qs('.arrow-link.pl').addEventListener('click', e => {
  trackSegmentAndLJ(e, 'Click 1: Payment Links', {
    email: sessionStorage.getItem('email')
      ? sessionStorage.getItem('email')
      : 'Not Filled',
    fold: 'fifth-fold',
    questions: allQuestAns.length ? allQuestAns : 'Not Answered'
  });
});

qs('.arrow-link.pp').addEventListener('click', e => {
  trackSegmentAndLJ(e, 'Click 2: Payment Pages', {
    email: sessionStorage.getItem('email')
      ? sessionStorage.getItem('email')
      : 'Not Filled',
    fold: 'fifth-fold',
    questions: allQuestAns.length ? allQuestAns : 'Not Answered'
  });
});

qs('.arrow-link.pb').addEventListener('click', e => {
  trackSegmentAndLJ(e, 'Click 3: Payment Buttons', {
    email: sessionStorage.getItem('email')
      ? sessionStorage.getItem('email')
      : 'Not Filled',
    fold: 'fifth-fold',
    questions: allQuestAns.length ? allQuestAns : 'Not Answered'
  });
});

qs('.arrow-link.more').addEventListener('click', e => {
  trackSegmentAndLJ(e, 'Click 4: Explore more', {
    email: sessionStorage.getItem('email')
      ? sessionStorage.getItem('email')
      : 'Not Filled',
    fold: 'fifth-fold',
    questions: allQuestAns.length ? allQuestAns : 'Not Answered'
  });
});
